<template>
  <div class="layer seatMap">
    <div class="inner reservationDetail">
        <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
        <h2 class="layerTitle">{{section.name[lang.default]}} {{locale.reservation_section_individual_seat}}</h2>
        <div>
          <div class="flexBox mb30">
            <div class="flexInner checkbox">
              <input type="checkbox" id="show_place" v-model="showPlaceName">
              <label for="show_place">{{locale.reservation_show_placename}}</label>
            </div>
            <div class="flexInner checkbox">
              <input type="checkbox" id="show_seat" v-model="showSeatName">
              <label for="show_seat">{{locale.reservation_show_seatname}}</label>
            </div>
            <div class="flexInner"></div>
          </div>
          <div class="ground">
            <!-- object:: top -->
            <div class="objects top">
              <VueDragResize v-for="(obj, index) in objects.top"
                :key="`top_${obj.object}_${index}`"
                :minw="objOptions.w"
                :minh="objOptions.h"
                :w="obj.w"
                :h="obj.h"
                :x="obj.x"
                :y="obj.y"
                :parentW="objParent.top.w"
                :parentH="objParent.top.h"
                :gridX="objOptions.w"
                :gridY="objOptions.h"
                :isActive="true"
                :snapToGrid="true"
                :parentLimitation="true"
                :sticks="['mr', 'ml']"
                data-position="top"
                :data-index="index"
                :data-active="activeObject && activeObject.index === index && activeObject.position === 'top'"
                @clicked="activeObj"
                @resizing="resizeObj"
                @dragging="resizeObj">
                <span class="obj"
                  :data-obj="obj.object">
                  <button type="button" class="btnDel" @click="delObject('top', obj.object, index)"></button>
                </span>
              </VueDragResize>
            </div>
            <!-- //object:: top -->
            <!-- object:: bottom -->
            <div class="objects bottom">
              <VueDragResize v-for="(obj, index) in objects.bottom"
                :key="`bottom_${obj.object}_${index}`"
                :minw="objOptions.w"
                :minh="objOptions.h"
                :w="obj.w"
                :h="obj.h"
                :x="obj.x"
                :y="obj.y"
                :parentW="objParent.bottom.w"
                :parentH="objParent.bottom.h"
                :gridX="objOptions.w"
                :gridY="objOptions.h"
                :isActive="true"
                :snapToGrid="true"
                :parentLimitation="true"
                :sticks="['mr', 'ml']"
                data-position="bottom"
                :data-index="index"
                :data-active="activeObject && activeObject.index === index && activeObject.position === 'bottom'"
                @clicked="activeObj"
                @resizing="resizeObj"
                @dragging="resizeObj">
                <span class="obj"
                  :data-obj="obj.object">
                  <button type="button" class="btnDel" @click="delObject('bottom', obj.object, index)"></button>
                </span>
              </VueDragResize>
            </div>
            <!-- //object:: bottom -->
            <!-- object:: left -->
            <div class="objects left">
              <VueDragResize v-for="(obj, index) in objects.left"
                :key="`left_${obj.object}_${index}`"
                :minw="objOptions.w"
                :minh="objOptions.h"
                :w="obj.w"
                :h="obj.h"
                :x="obj.x"
                :y="obj.y"
                :parentW="objParent.left.w"
                :parentH="objParent.left.h"
                :gridX="objOptions.w"
                :gridY="objOptions.h"
                :isActive="true"
                :snapToGrid="true"
                :parentLimitation="true"
                :sticks="['tm', 'bm']"
                data-position="left"
                :data-index="index"
                :data-active="activeObject && activeObject.index === index && activeObject.position === 'left'"
                @clicked="activeObj"
                @resizing="resizeObj"
                @dragging="resizeObj">
                <span class="obj"
                  :data-obj="obj.object">
                  <button type="button" class="btnDel" @click="delObject('left', obj.object, index)"></button>
                </span>
              </VueDragResize>
            </div>
            <!-- //object:: left -->
            <!-- object:: right -->
            <div class="objects right">
              <VueDragResize v-for="(obj, index) in objects.right"
                :key="`right_${obj.object}_${index}`"
                :minw="objOptions.w"
                :minh="objOptions.h"
                :w="obj.w"
                :h="obj.h"
                :x="obj.x"
                :y="obj.y"
                :parentW="objParent.right.w"
                :parentH="objParent.right.h"
                :gridX="objOptions.w"
                :gridY="objOptions.h"
                :isActive="true"
                :snapToGrid="true"
                :parentLimitation="true"
                :sticks="['tm', 'bm']"
                data-position="right"
                :data-index="index"
                :data-active="activeObject && activeObject.index === index && activeObject.position === 'right'"
                @clicked="activeObj"
                @resizing="resizeObj"
                @dragging="resizeObj">
                <span class="obj"
                  :data-obj="obj.object">
                  <button type="button" class="btnDel" @click="delObject('right', obj.object, index)"></button>
                </span>
              </VueDragResize>
            </div>
            <!-- //object:: right -->
            <!-- seat map -->
            <div class="seatsBg">
              <div id="seats" class="seats">
                <div v-for="seat in seats"
                  :key="seat.seatId">
                  <VueDragResize
                    :data-seat="seat.seatId"
                    :data-active="activeSeat && activeSeat.seat === seat.seatId"
                    :minw="w / 2"
                    :minh="h / 2"
                    :w="seat.w"
                    :h="seat.h"
                    :x="seat.x"
                    :y="seat.y"
                    :parentW="listWidth"
                    :parentH="listHeight"
                    :gridX="w / 4"
                    :gridY="h / 4"
                    :isActive="true"
                    :snapToGrid="true"
                    :parentLimitation="true"
                    @clicked="active"
                    @resizing="resize"
                    @dragging="resize">
                    <div class="filler"
                      :class="{disabled: seat.disabled}">
                      <span v-if="seat.placeName[lang.default].length && showPlaceName"
                        class="place"
                        :style="{backgroundColor: seat.color}">
                        {{seat.placeName[lang.default]}}
                      </span>
                      <span v-if="showSeatName" class="seat">{{seat.name[lang.default]}}</span>
                    </div>
                  </VueDragResize>
                </div>
              </div>
            </div>
            <!-- //seat map -->
          </div>
        </div>
        <div class="setObject flexBox mt30">
          <div class="flexInner">
            <p class="label mb5">{{locale.add_window}}</p>
            <div class="btnGroup" data-obj="window">
              <button type="button" class="btnSet btnTop" @click="addObject('top', 'window')"><span class="blind">top</span></button>
              <button type="button" class="btnSet btnBottom" @click="addObject('bottom', 'window')"><span class="blind">bottom</span></button>
              <button type="button" class="btnSet btnLeft" @click="addObject('left', 'window')"><span class="blind">left</span></button>
              <button type="button" class="btnSet btnRight" @click="addObject('right', 'window')"><span class="blind">right</span></button>
            </div>
          </div>
          <div class="flexInner">
            <p class="label mb5">{{locale.add_entrance}}</p>
            <div class="btnGroup" data-obj="entrance">
              <button type="button" class="btnSet btnTop" @click="addObject('top', 'entrance')"><span class="blind">top</span></button>
              <button type="button" class="btnSet btnBottom" @click="addObject('bottom', 'entrance')"><span class="blind">bottom</span></button>
              <button type="button" class="btnSet btnLeft" @click="addObject('left', 'entrance')"><span class="blind">left</span></button>
              <button type="button" class="btnSet btnRight" @click="addObject('right', 'entrance')"><span class="blind">right</span></button>
            </div>
          </div>
          <div class="flexInner"></div>
        </div>
        <div class="btns">
          <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.apply}}</button>
        </div>
    </div>
  </div>
</template>

<script>
import VueDragResize from 'vue-drag-resize'

export default {
  name: 'SetReservationItem',
  props: [
    'locale',
    'lang',
    'section'
  ],
  components: {
    VueDragResize
  },
  computed: {
    places () {
      return this.section.place.map((x, i) => {
        return {
          id: x.placeId,
          color: this.colors[i % this.colors.length],
          disabled: x.disabled
        }
      })
    }
  },
  watch: {
    section: {
      deep: true,
      immediate: true,
      handler (data) {
        
      }
    }
  },
  mounted () {
    const seatMap = this.section.seatMap
    const places = this.section.place
    // set seat
    let list = []
    for (let i = 0; i < places.length; i++) {
      const place = places[i]
      const seats = this._.cloneDeep(place.seat)
      for (let j = 0; j < seats.length; j++) {
        const seat = seats[j]
        const seatMapInfo = seatMap ? seatMap.find(x => (x.placeId === place.placeId) && (x.seatId === seat.seatId)) : null
        seat.placeId = place.placeId
        seat.placeName = place.name
        seat.disabled = this.places.find(x => x.id === place.placeId).disabled
        seat.color = this.places.find(x => x.id === place.placeId).color
        /**
         * 실제로 w, h, x, y 값만 seats 데이터에서 필요로 함
         * 나머지는 section.place와 매핑하여
         * 실시간 반영 해야함
         * 여기서 굳이 매핑한 이유는 display 때문
         */
        seat.w = seatMapInfo ? seatMapInfo.w : this.w
        seat.h = seatMapInfo ? seatMapInfo.h : this.h
        // seat.x = seatMapInfo ? seatMapInfo.x : this.getPositionX(j)
        // seat.y = seatMapInfo ? seatMapInfo.y : this.getPositionY(j)
        list.push(seat)
      }
    }
    list = list.map((x, i) => {
      const seatItem = seatMap ? seatMap.find(s => s.placeId === x.placeId && s.seatId === x.seatId) : null
      return {
        ...x,
        x: seatMap && seatItem ? seatItem.x : this.getPositionX(i),
        y: seatMap && seatItem ? seatItem.y : this.getPositionY(i)
      }
    })
    this.seats = list
    this.showPlaceName = this.section.showPlaceName !== false // undefined여도 true
    this.showSeatName = this.section.showSeatName !== false // undefined여도 true
    // set objects
    this.objects = { ...this.objects, ...this.section.seatObj }
  },
  data () {
    return {
      use: false,
      listWidth: 600,
      listHeight: 400,
      w: 100,
      h: 100,
      itemX: 0,
      itemY: 0,
      colors: [
        '#ed5564',
        '#eda605',
        '#68b11b',
        '#4fa8e8',
        '#ac92eb'
      ],
      seats: [],
      activeSeat: null,
      objOptions: {
        w: 25,
        h: 25,
        window: {
          tb: {
            w: 160,
            h: 25,
            x: 0,
            y: 0
          },
          lr: {
            w: 25,
            h: 160,
            x: 0,
            y: 25
          }
        },
        entrance: {
          tb: {
            w: 160,
            h: 25,
            x: 440,
            y: 0
          },
          lr: {
            w: 25,
            h: 160,
            x: 0,
            y: 265
          }
        }
      },
      objParent: {
        top: {
          w: 600,
          h: 25
        },
        bottom: {
          w: 600,
          h: 25
        },
        left: {
          w: 25,
          h: 450
        },
        right: {
          w: 25,
          h: 450
        }
      },
      objects: {
        top: [],
        bottom: [],
        left: [],
        right: []
      },
      activeObject: null,
      showPlaceName: true,
      showSeatName: true
    }
  },
  methods: {
    active (e) {
      if (e.currentTarget) {
        const seatId = e.currentTarget.getAttribute('data-seat')
        const seat = this.seats.find(x => x.seatId === seatId)
        if (seat) {
          this.activeSeat = { place: seat.placeId, seat: seat.seatId }
          this.activeObject = null
        }
      }
    },
    resize (data) {
      if (this.activeSeat) {
        const placeId = this.activeSeat.place
        const seatId = this.activeSeat.seat
        const seat = this.seats.find(x => x.placeId === placeId && x.seatId === seatId)
        if (seat) {
          this.activeSeat = {
            ...this.activeSeat,
            ...data
          }
          seat.w = data.width
          seat.h = data.height
          seat.x = data.left
          seat.y = data.top
        }
      }
    },
    getPositionX (index) {
      const itemX = parseInt(this.listWidth / this.w)
      return parseInt(index % itemX) * this.w
    },
    getPositionY (index) {
      const itemX = parseInt(this.listWidth / this.w)
      return parseInt(index / itemX) * this.h
    },
    getColor (seat) {
      return this.places.find(x => x.id === seat.placeId).color
    },
    addObject (position, obj) {
      const data = {
        object: obj,
        ...(position === 'top' || position === 'bottom') && {
          ...this.objOptions[obj].tb
        },
        ...(position === 'left' || position === 'right') && {
          ...this.objOptions[obj].lr
        }
      }
      this.objects[position].push(data)
    },
    delObject (position, obj, index) {
      const objLocale = this.locale[obj]
      if (window.confirm(this.locale.confirm_delete_reservation_object.replace('{var}', objLocale))) {
        this.objects[position] = this.objects[position].filter((x, idx) => !(idx === index && x.object === obj))
        this.activeObject = null
      }
    },
    activeObj (e) {
      if (e.currentTarget) {
        const objPos = e.currentTarget.getAttribute('data-position')
        const objIdx = e.currentTarget.getAttribute('data-index')
        this.activeObject = { position: objPos, index: Number(objIdx) }
        this.activeSeat = null
      }
    },
    resizeObj (data) {
      const position = this.activeObject.position
      const index = this.activeObject.index
      const object = this.objects[position][index]
      object.w = data.width
      object.h = data.height
      object.x = data.left
      object.y = data.top
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel_setting_section)) {
        this.$emit('close')
      }
    },
    save () {
      if (window.confirm(this.locale.confirm_confirm_setting_section)) {
        const data = {
          use: this.use,
          seats: this.seats,
          objects: this.objects,
          showPlaceName: this.showPlaceName,
          showSeatName: this.showSeatName
        }
        this.$emit('save', data)
      }
    }
  }
}
</script>
